import { setGetViewLotteryAction } from '../action';
import { getByIdLottery } from '../api/getByIdLottery';

const setGetByIdLottery = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getByIdLottery(params);

            if (data.status === 'success') {
                dispatch(setGetViewLotteryAction({
                    id: data.data.id,
                    start: data.data.date_from,
                    end: data.data.date_to,
                    label_name: data.data.label,
                    description: data.data.description,
                    fund: data.data.fund,
                    count_winners: data.data.count_winners,
                    winners: data.data.top_places,
                    price_ticket_deposit: data.data.price_ticket_deposit,
                    price_ticket: data.data.price_ticket,
                    gold_ticket: data.data.gold_ticket,
                    status: data.data.status
                }));
            }

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetByIdLottery
}